require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./epfl-genve-0-4-4.json") })
        }
      }, "path---epfl-genve-0-4-4");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---epfl-genve-0-4-4!./.cache/json/epfl-genve-0-4-4.json
// module id = 414
// module chunks = 231608221292675